import { grinders } from "../grinders";
import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import logo from '../assets/beanclopedia.png'; 
import { coffeeBeans } from "../coffeeBeans";

export default function GrindForm() {
  const [form, setForm] = useState({
    grinder: "",
    brewMethod: "",
    bean: "",
    roastLevel: "",
    roaster: "",
    grindSetting: "",
    notes: ""
  });

  const [coffeeSuggestions, setCoffeeSuggestions] = useState([]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCoffeeInput = (e) => {
    const value = e.target.value;
    setForm((prevForm) => {
      const matchedBean = coffeeBeans.find(
        (bean) => bean.name.toLowerCase() === value.toLowerCase()
      );

      return {
        ...prevForm,
        bean: value,
        roastLevel: matchedBean ? matchedBean.roast : "",
        roaster: matchedBean ? matchedBean.roaster : ""
      };
    });

    const filtered = coffeeBeans
      .filter((bean) =>
        bean.name.toLowerCase().includes(value.toLowerCase())
      )
      .map((bean) => bean.name);

    setCoffeeSuggestions(filtered);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "grindSettings"), {
        ...form,
        timestamp: serverTimestamp()
      });
      alert("Grind setting submitted!");
      setForm({
        grinder: "",
        brewMethod: "",
        bean: "",
        roastLevel: "",
        roaster: "",
        grindSetting: "",
        notes: ""
      });
    } catch (error) {
      console.error("Error submitting: ", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-white text-black rounded-xl shadow-xl p-6 w-full max-w-md space-y-4"
    >
      <img 
        src={logo} 
        alt="Beanclopedia logo" 
        style={{
          height: '240px',
          marginBottom: '1rem'
        }} 
      />
      <h2 className="text-2xl font-bold text-center text-[#4b2e2e]">
        Submit a Grind Setting
      </h2>

      <select
        name="grinder"
        value={form.grinder}
        onChange={handleChange}
        className="w-full p-3 border border-gray-300 rounded-lg"
        required
      >
        <option value="">Select Grinder</option>
        {grinders.map((g, idx) => (
          <option key={idx} value={g}>{g}</option>
        ))}
      </select>

      <select
        name="brewMethod"
        value={form.brewMethod}
        onChange={handleChange}
        className="w-full p-3 border border-gray-300 rounded-lg"
        required
      >
        <option value="">Select Brew Method</option>
        <option>French Press</option>
        <option>Pour Over</option>
        <option>Espresso</option>
        <option>AeroPress</option>
      </select>

      <input
        name="bean"
        value={form.bean}
        onChange={handleCoffeeInput}
        placeholder="Coffee Bean (e.g. Ethiopia Yirgacheffe)"
        list="coffee-bean-options"
        className="w-full p-3 border border-gray-300 rounded-lg"
        required
      />

      <datalist id="coffee-bean-options">
        {coffeeSuggestions.map((bean, idx) => (
          <option key={idx} value={bean} />
        ))}
      </datalist>

      <input
        name="roastLevel"
        value={form.roastLevel}
        readOnly
        placeholder="Roast Level"
        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 cursor-not-allowed"
      />

      <input
        name="roaster"
        value={form.roaster}
        readOnly
        placeholder="Roaster"
        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 cursor-not-allowed"
      />

      <input
        name="grindSetting"
        value={form.grindSetting}
        onChange={handleChange}
        placeholder="Grind Setting (e.g. 18)"
        className="w-full p-3 border border-gray-300 rounded-lg"
        required
      />

      <textarea
        name="notes"
        value={form.notes}
        onChange={handleChange}
        placeholder="Notes (brew time, water temp, etc.)"
        className="w-full p-3 border border-gray-300 rounded-lg"
        rows={3}
      />

      <button
        type="submit"
        className="w-full bg-[#6e4c3a] text-white font-bold py-3 rounded-lg hover:bg-[#543828] transition"
      >
        Submit
      </button>
    </form>
  );
}